export function nonNull(value) {
  return value !== null;
}
